import React, { FC } from "react";
import moment from "moment";
import { Col, Progress, Row } from 'antd';
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { Card, List, Typography } from "antd";
import useHttpGet from "../../../hooks/useHttpGet";
import { APIRoutes } from "../../../http";
import { IResultResponse } from "../../../models/response/result.model";
import CommonService from "../../../services/common.service";
import HighChartsService from "../../../services/highcharts.service";

const Dashboard: FC = () => {
  const { fetchedData: data } = useHttpGet<IResultResponse<any[]>>(
    APIRoutes.DASHBOARD_INSTRUMENT_MOVEMENTS,
    {
      defaultValue: {
        result: [],
      },
    }
  );

  const { fetchedData: subscribes, loading } = useHttpGet<IResultResponse<any[]>>(
    `${APIRoutes.SUNSCRIBERS}`,
    {
      defaultValue: {} as IResultResponse<any[]>,
      reject: CommonService.showAllErrors,
      resolve: () => {
      }
    }
  );

  const { fetchedData: subscribesStats } = useHttpGet<IResultResponse<any>>(
    `${APIRoutes.SUNSCRIBERS}/stats`,
    {
      defaultValue: {} as IResultResponse<any>,
      reject: CommonService.showAllErrors,
      resolve: () => {
      }
    }
  );

  const getOptions = (data: any[]) => {
    const dataGrouped = CommonService.groupBy(data, "createdOnUtc");

    const chartData: any[] = [];
    const props = Object.getOwnPropertyNames(dataGrouped);
    props.forEach(f => {
      chartData.push({
        name: f,
        value: dataGrouped[f].length
      });
    });

    return {
      ...HighChartsService.baseSettings({
        chart: {
          type: "column",
          plotBackgroundImage: null
        },
        plotOptions: {
          series: {
            negativeColor: "#ce3e3e",
          },
        },
        series: [{
          name: "Subscribers per date",
          data: chartData.map(
            (el: any) => [
              moment(el?.name).unix() * 1000,
              el?.value,
            ]
          ),
        }],
      }),
    };
  }

  return (
    <Card loading={false}>
      <Row justify="center">
        <h3>Subscribes stats</h3>
        <Col className="mr-2">
          <Progress
            width={200}
            type="circle"
            strokeColor={{
              '0%': '#108ee9',
              '100%': '#87d068',
            }}
            percent={100}
            format={() => subscribesStats?.result?.total}
          />
          <p>Total</p>
        </Col>

        <Col className="mr-2">
          <Progress
            width={200}
            type="circle"
            strokeColor={{
              '0%': '#108ee9',
              '100%': '#87d068',
            }}
            percent={100 * subscribesStats?.result?.lastWeek / subscribesStats?.result?.total}
            format={() => subscribesStats?.result?.lastWeek}
          />
          <p>Last week</p>
        </Col>

        <Col className="mr-2">
          <Progress
            width={200}
            type="circle"
            strokeColor={{
              '0%': '#108ee9',
              '100%': '#87d068',
            }}
            percent={100 * subscribesStats?.result?.today / subscribesStats?.result?.total}
            format={() => subscribesStats?.result?.today}
          />
          <p>Today</p>
        </Col>
      </Row>
      <HighchartsReact
        highcharts={Highcharts}
        options={getOptions(subscribes.result)}
      />

      <List
        header={<div>Instrument movements</div>}
        bordered
        dataSource={data.result}
        renderItem={(item: any) => (
          <List.Item>
            <Typography.Text mark>{item?.title}</Typography.Text>
            {item?.contemt}
          </List.Item>
        )}
      />
    </Card>
  );
};

export default Dashboard;
